import { render, staticRenderFns } from "./BusinessUsersDelete.vue?vue&type=template&id=1e2e3aaa"
import script from "./BusinessUsersDelete.vue?vue&type=script&lang=js"
export * from "./BusinessUsersDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports